import { render, staticRenderFns } from "./BudgetMonitoringSetting.vue?vue&type=template&id=9020bde4&scoped=true"
import script from "./BudgetMonitoringSetting.vue?vue&type=script&lang=js"
export * from "./BudgetMonitoringSetting.vue?vue&type=script&lang=js"
import style0 from "./BudgetMonitoringSetting.vue?vue&type=style&index=0&id=9020bde4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9020bde4",
  null
  
)

export default component.exports